import type { CentsPerKmCopy } from "../../components/landing/calculator"

/** Chinese words of the cents per km calculator (T1320); the numbers come from the component. Terms: docs/design/landing/copy-zh.md. */
export const CENTS_PER_KM_COPY_ZH: CentsPerKmCopy = {
  heading: "cents per km 估算",
  kmLabel: "本收入年度的业务公里数",
  hint: (cap) => `用这种方法，每辆车最多可申报 ${cap} km。`,
  yearLabel: "收入年度",
  yearOption: (year, start) => `${year}（${start}年7月1日 – ${start + 1}年6月30日）`,
  deduction: "估算扣除额",
  working: (km, cents) => `${km} km × ${cents} c/km`,
  empty: "请输入业务公里数，查看估算结果。",
  invalid: "请填写整数公里数，例如 3,200。",
  overCap: (cap) =>
    `这种方法每辆车最多只算 ${cap} km。如果你的业务行驶更多，logbook 法可能扣除更多。`,
  note: "仅为估算，不构成税务建议。这个费率已包含燃油、车辆登记费、保险、维修和车辆折旧。",
}
